import { render, staticRenderFns } from "./Flowmanagement.vue?vue&type=template&id=b2f1e6f4&scoped=true&"
import script from "./Flowmanagement.vue?vue&type=script&lang=js&"
export * from "./Flowmanagement.vue?vue&type=script&lang=js&"
import style0 from "./Flowmanagement.vue?vue&type=style&index=0&id=b2f1e6f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f1e6f4",
  null
  
)

export default component.exports